__webpack_require__.p = "https://monocle.magmutual.com/";